export const getSquareApplicationErrorMessage = e =>
  `${e?.field ?? ''}: ${e?.message ?? ''}. ${e?.detail ?? ''}`;

/**
 * Square wants the charge amount as a major-unit string ('12.34'). Our order
 * totals are carried in milliunits, the same way selectDisplayTotal* renders
 * them.
 */
export const toSquareAmount = milliunits =>
  ((milliunits ?? 0) / 1000).toFixed(2);

const withoutEmptyValues = obj =>
  Object.fromEntries(
    Object.entries(obj).filter(([, value]) => !!value && value !== '(null)'),
  );

/**
 * Square uses the billing contact as a signal when deciding whether a buyer can
 * be approved without a challenge, so send everything we actually hold. We only
 * collect a billing address for Spreedly, so for Square this is name, email and
 * phone.
 */
export const buildSquareBillingContact = customerInfo =>
  withoutEmptyValues({
    givenName: customerInfo?.firstName,
    familyName: customerInfo?.lastName,
    email: customerInfo?.email,
    phone: customerInfo?.phoneNumber,
  });

/**
 * Square reports an unfinished 3DS challenge as a TokenizationError carrying a
 * VERIFICATION_ERROR. Closing the modal and failing verification in the browser
 * both land here - the Web Payments SDK gives no way to tell them apart, and
 * neither carries a code or any mention of cancelling.
 *
 * Either way no order was placed and nothing is broken, so this must not reach
 * the error boundary: the cart stays as it was and the shopper can try again.
 *
 * A wrong verification code does NOT come through here. The SDK still returns
 * an OK token and Square rejects it server side, which surfaces as a 500 from
 * makepayment.
 */
export const isBuyerVerificationError = e =>
  e?.errors?.some(({ type }) => type === 'VERIFICATION_ERROR') ?? false;
